import { jsx as _jsx } from "react/jsx-runtime";
import DOMPurify from "dompurify";
const SanitisedBackgroundImage = (props) => {
    return (_jsx("div", { className: props.className, style: {
            backgroundImage: "url(" + DOMPurify.sanitize(props.src) + ")",
        } }));
};
//<div className="login-hero-img" style={{backgroundImage: "url("+ config.heroImageUri +")"}}></div>
export default SanitisedBackgroundImage;
